var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4423 11H9.46923L6.97308 6.74313V11H6V5H6.97308L9.47692 9.27335V5H10.4423V11Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6192 11H11.65V5H12.6192V11Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7885 8.7706V11H13.8154V5H15.9577C16.5833 5 17.0795 5.17445 17.4462 5.52335C17.8154 5.87225 18 6.33379 18 6.90797C18 7.49588 17.8192 7.9533 17.4577 8.28022C17.0987 8.60714 16.5949 8.7706 15.9462 8.7706H14.7885ZM14.7885 7.93407H15.9577C16.3038 7.93407 16.5679 7.84753 16.75 7.67445C16.9321 7.49863 17.0231 7.24588 17.0231 6.91621C17.0231 6.59203 16.9308 6.33379 16.7462 6.14148C16.5615 5.94643 16.3077 5.84615 15.9846 5.84066H14.7885V7.93407Z",
    fill: "#6C757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2H4.5C3.65625 2 3 2.6875 3 3.5V14.5C3 15.3438 3.65625 16 4.5 16H19.5C20.3125 16 21 15.3438 21 14.5V3.5C21 2.6875 20.3125 2 19.5 2ZM20 14.5C20 14.7812 19.75 15 19.5 15H4.5C4.21875 15 4 14.7812 4 14.5V3.5C4 3.25 4.21875 3 4.5 3H19.5C19.75 3 20 3.25 20 3.5V14.5ZM9 12.375C9 12.1875 8.8125 12 8.625 12H6.375C6.15625 12 6 12.1875 6 12.375V12.625C6 12.8438 6.15625 13 6.375 13H8.625C8.8125 13 9 12.8438 9 12.625V12.375ZM16 12.375C16 12.1875 15.8125 12 15.625 12H11.375C11.1562 12 11 12.1875 11 12.375V12.625C11 12.8438 11.1562 13 11.375 13H15.625C15.8125 13 16 12.8438 16 12.625V12.375Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.ad196818.svg";
export { ForwardRef as ReactComponent };